<template>
  <div class="mediastorage">
    <h1>Медиахранилище</h1>
    <MediaFiles />
  </div>
</template>

<script>
import MediaFiles from '@/components/MediaFiles/MediaFiles';
import './index.scss';

export default {
  name: "MediaStorage",
  components: {
    MediaFiles,
  },
  data() {
    return {
      exitMenuVisible: false,
    };
  },
  methods: {
  },
  computed: {
  },
  created() {
    // console.log(this.$route);
  },
};
</script>
